module.exports = __webpack_public_path__ + "img/Logo.f6f30987.svg";